import React from 'react';
import styled from 'styled-components';

function Main({ className }) {
  const htmlContent = `<!DOCTYPE html><html><head>
<meta charset="UTF-8" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<title>2 Porri - Il Maestro del LoFi Italiano da Cagliari</title>

<link rel="stylesheet" href="https://api.websim.ai/fonts.css">
<link rel="stylesheet" href="https://api.websim.ai/ctxmenu.css">

<style>
  .bodyb {
    font-family: 'Comic Sans MS', 'Chalkboard SE', 'Comic Neue', sans-serif;
    background: url('https://lofi.2porri.it/assets/bg_cagliari_porri.gif') repeat;
    color: #00FF00;
    margin: 0;
    padding: 0;
    cursor: url('https://lofi.2porri.it/assets/porro_cursor.png'), auto;
  }
  .container {
    /* Ora il contenitore è flessibile */
    max-width: 800px;
    width: 100%;
    margin: 0 auto;
    background-color: rgba(0, 0, 0, 0.7);
    border: 3px solid #FF00FF;
    padding: 20px;
  }
  header {
    text-align: center;
    margin-bottom: 20px;
  }
  h1 {
    font-size: 48px;
    color: #FFFF00;
    text-shadow: 2px 2px #FF0000, -2px -2px #0000FF;
    animation: blink 1s infinite;
  }
  @keyframes blink {
    0% { opacity: 1; }
    50% { opacity: 0; }
    100% { opacity: 1; }
  }
  .subtitle {
    font-size: 24px;
    color: #00FFFF;
  }
  .navbar {
    background-color: #000000;
    text-align: center;
    padding: 10px 0;
  }
  .navbar a {
    color: #FFFFFF;
    text-decoration: none;
    padding: 5px 10px;
    margin: 0 5px;
    border: 1px solid #FFFFFF;
  }
  .navbar a:hover {
    background-color: #FFFFFF;
    color: #000000;
  }
  .content {
    display: flex;
    justify-content: space-between;
  }
  .main-content {
    width: 70%;
  }
  .sidebar {
    width: 25%;
  }
  .ad-banner {
    background-color: #FFFF00;
    border: 2px dashed #FF0000;
    padding: 10px;
    margin: 10px 0;
    text-align: center;
    font-weight: bold;
    color: #0000FF;
  }
  .footer {
    background-color: #000000;
    color: #FFFFFF;
    text-align: center;
    padding: 10px 0;
    margin-top: 20px;
  }
  .hit-counter {
    font-family: 'Digital', monospace;
    background-color: #000000;
    color: #FF0000;
    padding: 5px;
    display: inline-block;
  }
  marquee {
    background-color: #FF00FF;
    color: #FFFFFF;
    padding: 5px 0;
  }
  .popup-ad {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #FFFFFF;
    border: 5px solid #FF00FF;
    padding: 20px;
    z-index: 1000;
    display: none;
  }
  .close-ad {
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
  }
  .floating-ad {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #00FFFF;
    border: 2px solid #FF0000;
    color: black;
    padding: 10px;
    animation: float 3s ease-in-out infinite;
  }
  @keyframes float {
    0% { transform: translateY(0px); }
    50% { transform: translateY(-20px); }
    100% { transform: translateY(0px); }
  }

  /* Responsive Styles */
  @media (max-width: 768px) {
    .container {
      /* Resta al 95% max anziché 800px fissi */
      width: 95%;
      padding: 10px;
      margin: 10px auto;
    }
    .content {
      flex-direction: column;
      gap: 20px;
    }
    .main-content, .sidebar {
      width: 100%;
    }
    .ad-banner {
      font-size: 14px;
      padding: 8px;
      margin: 10px 0;
    }
    h1 {
      font-size: 32px;
      text-shadow: 1px 1px #FF0000, -1px -1px #0000FF;
    }
    .subtitle {
      font-size: 18px;
    }
    .navbar {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 5px;
    }
    .navbar a {
      display: inline-block;
      margin: 5px 2px;
      font-size: 14px;
      padding: 4px 6px;
    }
    .floating-ad {
      bottom: 10px;
      right: 10px;
      padding: 6px;
      font-size: 13px;
      width: 90%;
      text-align: center;
      color: black;
    }
    .popup-ad {
      width: 90%;
      color: black;
      font-size: 14px;
      padding: 15px;
    }
    marquee {
      font-size: 14px;
    }
    img {
      max-width: 100%;
      height: auto;
    }
    ul {
      padding-left: 20px;
    }
    .hit-counter {
      font-size: 12px;
    }
  }

  @media (max-width: 480px) {
    .container {
      width: 100%;
      padding: 5px;
    }
    h1 {
      font-size: 24px;
    }
    .subtitle {
      font-size: 16px;
    }
    .ad-banner {
      font-size: 12px;
      padding: 6px;
    }
    .navbar a {
      font-size: 12px;
      padding: 3px 5px;
    }
    .floating-ad {
      font-size: 11px;
      padding: 5px;
    }
    .popup-ad {
      font-size: 12px;
      padding: 10px;
    }
    marquee {
      font-size: 12px;
    }
    .footer {
      font-size: 12px;
    }
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    .container {
      width: 90%;
    }
    .content {
      gap: 15px;
    }
    .main-content {
      width: 65%;
    }
    .sidebar {
      width: 30%;
    }
    h1 {
      font-size: 36px;
    }
    .subtitle {
      font-size: 20px;
    }
  }
</style>
</head>
<div class="bodyb">

<marquee scrollamount="5" behavior="alternate" w-tid="17">🎵 NUOVO ALBUM "PORRO BEATS VOL. 2: CAGLIARI LOFI" IN USCITA! 🎵 CLICCA QUI PER PREORDINARE! 🎵 OFFERTA LIMITATA: ACQUISTA ORA E RICEVI UN PORRO USB DA 1TB A FORMA DEL BASTIONE DI SAINT REMY! 🎵</marquee>


    <div class="container" w-tid="31">
        <header w-tid="33">
            <h1 w-tid="35">2 Porri</h1>
            <p class="subtitle" w-tid="37">Il Maestro del LoFi Italiano dal Cuore di Cagliari</p>
        </header>

        <div class="ad-banner" style="background-color: #FF00FF; color: #FFFFFF;" w-tid="39">
            🚀 NOVITÀ ASSOLUTA: PoFi SPACE CAGLIARI 🚀<br w-tid="41"/>
            Ascolta LoFi dalla Torre dell'Elefante!<br w-tid="43"/>
            Abbonati ora e ricevi un casco da astronauta a forma di Su Nenniri!
        </div>

        <div class="content" w-tid="45">
            <div class="main-content" w-tid="47">
                <h2 w-tid="49">Benvenuti nel mondo di 2 Porri, direttamente da Cagliari!</h2>
                <p w-tid="51">Qui troverai i beats più freschi e croccanti del Mediterraneo. La mia musica è come un porro del Mercato di San Benedetto: ha strati di sapore e ti fa piangere... di gioia!</p>
                
                <div class="ad-banner" style="background-color: #00FFFF; color: #FF0000;" w-tid="53">
                    💊 PILLOLE DI PORRO ALLA SARDA 💊<br w-tid="55"/>
                    Il nuovo integratore per musicisti LoFi di Cagliari!<br w-tid="57"/>
                    Aumenta la tua creatività del 200% e la tua voglia di fregola del 300%*<br w-tid="59"/>
                    <small w-tid="61">*risultati non garantiti, può causare allucinazioni a base di Su Porcheddu</small>
                </div>

                <h3 w-tid="63">Ultime Uscite ispirate a Cagliari:</h3>
                <ul w-tid="65">
                    <li w-tid="67">🎵 "Porro in the Poetto Rain"</li>
                    <li w-tid="69">🎵 "Zuppa LoFi al Mercato di San Benedetto"</li>
                    <li w-tid="71">🎵 "Beats & Bietole del Campidano"</li>
                </ul>

                <div class="ad-banner" w-tid="73">
                    💥 OFFERTA SPECIALE CAGLIARITANA! 💥<br w-tid="75"/>
                    Acquista l'album "Porro Beats Vol. 1: Suoni dal Golfo degli Angeli" e ricevi in OMAGGIO un vero porro autografato coltivato nei Giardini Pubblici!<br w-tid="77"/>
                    + BONUS: Un corso online "Come coltivare porri LoFi nel tuo balcone vista Sella del Diavolo"
                </div>
            </div>

            <div class="sidebar" w-tid="79">
                <div class="ad-banner" w-tid="81">
                    🔥 NOVITÀ 🔥<br w-tid="83"/>
                    PoFi Player Cagliari Edition<br w-tid="85"/>
                    Il walkman del futuro, made in Sardegna!<br w-tid="87"/>
                    Riproduce solo LoFi e odora di porro e mirto
                </div>

                <img src="https://lofi.2porri.it/assets/2porri_cagliari_avatar.gif" alt="2 Porri Avatar con sfondo Castello di Cagliari" style="width:100%; border: 2px solid #00FF00;" w-tid="89"/>

                <div class="ad-banner" style="background-color: #FF1493; color: #FFFFFF;" w-tid="91">
                    🎮 NUOVO VIDEOGIOCO 🎮<br w-tid="93"/>
                    "LoFi Farmer Simulator: Cagliari Edition"<br w-tid="95"/>
                    Coltiva porri e componi beats nei campi di Mulinu Becciu!<br w-tid="97"/>
                    Diventa il miglior contadino LoFi della Sardegna!
                </div>

                <div class="ad-banner" w-tid="99">
                    👕 NUOVO MERCH 👕<br w-tid="101"/>
                    T-shirt "Sono un Porro LoFi di Cagliari"<br w-tid="103"/>
                    Con aroma di porro che dura 100 lavaggi nell'acqua del Poetto!
                </div>
            </div>
        </div>

        <footer class="footer" w-tid="105">
            © 2023 2 Porri Productions, Via Roma 143, Cagliari. Tutti i diritti riservati.<br w-tid="107"/>
            Nessun porro sardo è stato maltrattato nella produzione di questa musica.<br w-tid="109"/>
            <div class="hit-counter" w-tid="111">Visite: 000042069</div>
        </footer>
    </div>

    <div class="popup-ad" id="popupAd" w-tid="113">
        <span class="close-ad" onclick="closeAd()" w-tid="115">X</span>
        <h3 w-tid="117">🎉 CONGRATULAZIONI! 🎉</h3>
        <p w-tid="119">Sei il visitatore numero 1.000.000!*</p>
        <p w-tid="121">Hai vinto un viaggio all-inclusive nella Valle dei Porri di Cagliari e un concerto privato di 2 Porri sulla spiaggia del Poetto!</p>
        <small w-tid="123">*Numero generato casualmente ad ogni visita, come il tempo di attesa dei bus del CTM</small>
    </div>

    <div class="floating-ad" w-tid="125">
        💡 Lo sapevi? 💡<br w-tid="127"/>
        I porri di Cagliari che ascoltano LoFi crescono il 42% più velocemente e sono il 100% più saporiti!<br w-tid="129"/>
        Clicca qui per scoprire il segreto dei porri cagliaritani!
    </div>

    <script w-tid="131">
        // Popup ad
        setTimeout(function() {
            document.getElementById('popupAd').style.display = 'block';
        }, 5000);

        function closeAd() {
            document.getElementById('popupAd').style.display = 'none';
        }

        // Aggiungiamo un po' di divertimento anni '90 con tocco cagliaritano
        document.addEventListener('click', function(e) {
            const x = e.clientX;
            const y = e.clientY;
            const emojis = ['🥬', '🏖️', '🦩', '🌊', '🏰']; // Aggiunti emoji legati a Cagliari
            const emoji = document.createElement('div');
            emoji.textContent = emojis[Math.floor(Math.random() * emojis.length)];
            emoji.style.position = 'absolute';
            emoji.style.left = x + 'px';
            emoji.style.top = y + 'px';
            emoji.style.fontSize = '24px';
            emoji.style.pointerEvents = 'none';
            document.body.appendChild(emoji);
            setTimeout(() => emoji.remove(), 1000);
        });

        // Easter egg: clicca su "2 Porri" per una sorpresa sonora
        document.querySelector('h1').addEventListener('click', function() {
            alert('WOW! Hai trovato l\'easter egg! Sei un vero fan di 2 Porri! Hai vinto un porro d\'oro virtuale e un giro gratuito sulla ruota panoramica del Porto di Cagliari!');
            const audio = new Audio('https://lofi.2porri.it/assets/porro_cagliari_sound.mp3');
            audio.play();
        });
    </script>

</div></html>`;

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}

export default styled(Main)`
  height: 100%;
  width: 100%;
  overflow: auto;
`;
